import { render, staticRenderFns } from "./CarriageContractDetail.vue?vue&type=template&id=e9c13d82&scoped=true&"
import script from "./CarriageContractDetail.vue?vue&type=script&lang=js&"
export * from "./CarriageContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./CarriageContractDetail.vue?vue&type=style&index=0&id=e9c13d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c13d82",
  null
  
)

export default component.exports